import React, { useState, useEffect ,useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 

    faSignOutAlt,
    faEdit,
 
 
} from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import MenuFooter from './Component/MenuFooter';
import BuildCoin from './images/buildcoin.png';
import ArrowLeft from './images/ArrowLeft.png';
//import { onUserLogout } from '../utils/serviceWorkerUtils';
import { clearUserFromServiceWorker } from '../utils/serviceWorkerUtils';

function ProfileAccount() {
    const navigate = useNavigate();
    const [userData, setUserData] = useState({});
    const [customerData, setCustomerData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [walletBalance, setWalletBalance] = useState(0);
    const [editingProfile, setEditingProfile] = useState(false);
    const [editingContact, setEditingContact] = useState(false);
  const [showFirmTypeDropdown, setShowFirmTypeDropdown] = useState(false);
    const [showAssociationDropdown, setShowAssociationDropdown] = useState(false);
   const [isSaving, setIsSaving] = useState(false);
const [showPopup, setShowPopup] = useState(false);
const [popupMessage, setPopupMessage] = useState('');
const [popupType, setPopupType] = useState('');
const [gstError, setGstError] = useState('');
const [mobileError, setMobileError] = useState('');


 const firmTypeRef = useRef(null);
    const associationRef = useRef(null);

    const [profileForm, setProfileForm] = useState({
        customer_name: '',
        mobile_number: ''
    });
    const [contactForm, setContactForm] = useState({
        company_name: '',
        type_of_firm: '',
        gstin: '',
        pan: '',
        association: ''
    });

    useEffect(() => {
        loadUserData();
    }, []);

    useEffect(() => {
        if (userData._id) {
            getCustomerDetails(userData._id);
            getBuildcoinsWallet();
        }
    }, [userData]);

    useEffect(() => {
        if (customerData) {
            setProfileForm({
                customer_name: customerData.customer_name || '',
                mobile_number: customerData.mobile_number || ''
            });
            setContactForm({
                company_name: customerData.company_name || '',
                type_of_firm: customerData.type_of_firm || '',
                gstin: customerData.gstin || '',
                pan: customerData.pan || '',
                association: customerData.association || ''
            });
        }
    }, [customerData]);

    const loadUserData = () => {
        try {
            const storedData = localStorage.getItem('userData');
            if (storedData) {
                const parsedData = JSON.parse(storedData);
                setUserData(parsedData);
            } else {
                const sessionData = sessionStorage.getItem('userData');
                if (sessionData) {
                    const parsedData = JSON.parse(sessionData);
                    setUserData(parsedData);
                }
            }
        } catch (error) {
            console.error("Error loading user data:", error);
            setError("Failed to load user data");
        } finally {
            setLoading(false);
        }
    };


  useEffect(() => {
        function handleClickOutside(event) {
            if (firmTypeRef.current && !firmTypeRef.current.contains(event.target)) {
                setShowFirmTypeDropdown(false);
            }
            if (associationRef.current && !associationRef.current.contains(event.target)) {
                setShowAssociationDropdown(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);



    const getCustomerDetails = async (customerId) => {
        const token = userData?.token || sessionStorage.getItem('token');
        
        try {
            setLoading(true);
            const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}customer/get-customer-by-customerId?customer_id=${customerId}`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'x-token': token
                }
            });
            
            const result = await response.json();
            
            if (result.success) {
                setCustomerData(result.data);
                console.log("Customer Details:", result.data);
            } else {
                console.error('Failed to fetch customer:', result.message);
            }
        } catch (error) {
            console.error('Error:', error);
        }
        finally {
            setLoading(false);
        }
    };

const handleProfileSave = async () => {
    setIsSaving(true);
    
    try {
        const token = userData?.token || sessionStorage.getItem('token');
        const customerId = userData?._id;
        console.log('Customer ID:', customerId);
        console.log('Token:', token);
        
        if (!customerId || !token) {
            console.error('Customer ID or token not found');
            setIsSaving(false);
            return;
        }

        // Remove query parameter from URL since backend expects _id in body
        const saveUrl = `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/update-customer-from-profilepage`;
        
        const requestData = {
            _id: customerId, 
            customer_name: profileForm.customer_name,
            mobile_number: profileForm.mobile_number,
          
        };

        const response = await fetch(saveUrl, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'x-token': token,
            },
            body: JSON.stringify(requestData),
        });

        const responseData = await response.json();
        console.log('Profile update response:', responseData);

        if (responseData.success || responseData.status === 200 || responseData.status === 201) {
            setIsSaving(false);
            setEditingProfile(false);
            
            // Update local customer data
            setCustomerData(prev => ({
                ...prev,
                customer_name: profileForm.customer_name,
                mobile_number: profileForm.mobile_number
            }));
            
            setPopupMessage(responseData.message || 'Profile updated successfully');
            setPopupType('success');
            setShowPopup(true);
            
            setTimeout(() => {
                setShowPopup(false);
            }, 3000);
        } else {
            setIsSaving(false);
            setPopupMessage(responseData.message || 'Failed to update profile');
            setPopupType('error');
            setShowPopup(true);
            
            setTimeout(() => {
                setShowPopup(false);
            }, 3000);
        }
    } catch (error) {
        console.error('Error updating profile:', error);
        setIsSaving(false);
        setPopupMessage('Network error occurred');
        setPopupType('error');
        setShowPopup(true);
        
        setTimeout(() => {
            setShowPopup(false);
        }, 3000);
    }
};

const handleContactSave = async () => {
    setIsSaving(true);
    
    try {
        const token = userData?.token || sessionStorage.getItem('token');
        const customerId = userData?._id;
        
        if (!customerId || !token) {
            console.error('Customer ID or token not found');
            setIsSaving(false);
            return;
        }

        // Use the same endpoint as profile update since it handles all customer fields
        const saveUrl = `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/update-customer-from-profilepage`;
        
        const requestData = {
            _id: customerId, // Add the customer ID to the request body
            // Keep existing profile data
            customer_name: customerData.customer_name,
            mobile_number: customerData.mobile_number,
            email: customerData.email,
            // Update contact fields
            company_name: contactForm.company_name,
            type_of_firm: contactForm.type_of_firm,
            gstin: contactForm.gstin,
            pan: contactForm.pan,
            association: contactForm.association,
            // Keep existing location data
            city: customerData.city,
            state: customerData.state
        };

        const response = await fetch(saveUrl, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'x-token': token,
            },
            body: JSON.stringify(requestData),
        });

        const responseData = await response.json();

        if (responseData.success || responseData.status === 200 || responseData.status === 201) {
            setIsSaving(false);
            setEditingContact(false);
            
            // Update local customer data
            setCustomerData(prev => ({
                ...prev,
                company_name: contactForm.company_name,
                type_of_firm: contactForm.type_of_firm,
                gstin: contactForm.gstin,
                pan: contactForm.pan,
                association: contactForm.association
            }));
            
            setPopupMessage(responseData.message || 'Contact information updated successfully');
            setPopupType('success');
            setShowPopup(true);
            
            setTimeout(() => {
                setShowPopup(false);
            }, 3000);
        } else {
            setIsSaving(false);
            setPopupMessage(responseData.message || 'Failed to update contact information');
            setPopupType('error');
            setShowPopup(true);
            
            setTimeout(() => {
                setShowPopup(false);
            }, 3000);
        }
    } catch (error) {
        console.error('Error updating contact information:', error);
        setIsSaving(false);
        setPopupMessage('Network error occurred');
        setPopupType('error');
        setShowPopup(true);
        
        setTimeout(() => {
            setShowPopup(false);
        }, 3000);
    }
};


    const getBuildcoinsWallet = async () => {
        const token = sessionStorage.getItem('token');
        const customer = JSON.parse(localStorage.getItem('userData'));
        const customerId = customer?._id;
        
        try {
            const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}customer/quotations/get-buildcoins-wallet?customer_id=${customerId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-token': token
                }
            });
                   
            const data = await response.json();
            setWalletBalance(data?.wallet?.available_coins || 0);
        } catch (err) {
            console.error('Error getting buildcoins wallet:', err);
        }
    };

  const handleLogout = () => {
  // Clear session storage
  sessionStorage.clear();
  
  // Clear all localStorage items
  const allKeys = Object.keys(localStorage);
  allKeys.forEach(key => {
    localStorage.removeItem(key);
  });

  // Clear service worker user data
  clearUserFromServiceWorker();
  
  // Navigate to login page
  navigate('/consumer');
};


    const getInitials = (name) => {
        if (!name) return 'U';
        return name.split(' ').map(word => word[0]).join('').toUpperCase().slice(0, 2);
    };

    const handleGstChange = (e) => {
  let gst = e.target.value.toUpperCase();

  // Limit input
  if (gst.length > 15) {
    setGstError('GST number must be exactly 15 characters');
    return;
  }

  const gstRegex =
    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

  // Less than 15 characters
  if (gst.length < 15) {
    setGstError('GST number must be 15 characters');
    setContactForm((prev) => ({
      ...prev,
      gstin: gst,
      pan: '',
    }));
    return;
  }

  // Invalid GST format
  if (!gstRegex.test(gst)) {
    setGstError('Enter GST in correct format (e.g., 29ABCDE1234F1Z5)');
    setContactForm((prev) => ({
      ...prev,
      gstin: gst,
      pan: '',
    }));
    return;
  }

  // ✅ Valid GST
  setGstError('');
  const extractedPan = gst.substring(2, 12);

  setContactForm((prev) => ({
    ...prev,
    gstin: gst,
    pan: extractedPan,
  }));
};

const handleMobileChange = (e) => {
  let value = e.target.value.replace(/\D/g, ''); // digits only

  if (value.length > 10) return;

  // Update value first
  setProfileForm((prev) => ({
    ...prev,
    mobile_number: value,
  }));

  // 1️⃣ Empty field → no error
  if (value.length === 0) {
    setMobileError('');
    return;
  }

  // 2️⃣ First digit validation (as soon as user types)
  if (!/^[6-9]/.test(value)) {
    setMobileError('Mobile number must start with 6, 7, 8, or 9');
    return;
  }

  // 3️⃣ Length validation
  if (value.length < 10) {
    setMobileError('Mobile number must be 10 digits');
    return;
  }

  // 4️⃣ Valid number
  setMobileError('');
};


   if (loading) {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-opacity-70 backdrop-blur-sm z-50">
      {/* 🔴 Red spinning circle */}
      <div className="w-8 h-8 border-2 border-red-400 border-t-transparent rounded-full animate-spin"></div>
      
      {/* Text below loader */}
      <p className="mt-4 text-gray-400 text-xs">Loading profile...</p>
    </div>
  );
}


    return (
        <div className="flex flex-col w-full min-h-screen bg-gray-50">
            {/* Header */}
            <div className="bg-white px-2 py-6 fixed sticky top-0 left-0 right-0 mt-2 flex items-center shadow-sm h-10">
                <img 
                    src={ArrowLeft} 
                    alt="Back" 
                    className="w-10 h-6 mr-2 cursor-pointer" 
                    onClick={() => navigate(-1)}
                />
                <h1 className="text-lg font-medium text-[#00000]">Profile</h1>
            </div>

            {/* User Profile Card */}
        <div className="mx-4 mt-4 bg-white rounded-lg p-4 shadow-sm">
    <div className="flex items-center justify-between mb-3">
        <div className="flex items-center">
            <div className="w-12 h-12 bg-[#D9E0F6] rounded-full flex items-center justify-center mr-3">
                <span className="text-[#1A73E7] font-bold text-lg">
                    {getInitials(customerData?.customer_name || userData?.customer_name)}
                </span>
            </div>
            <div>
                <h2 className="text-lg font-semibold text-[#00000]">
                    {customerData?.customer_name || userData?.customer_name || 'User Name'}
                </h2>
                <p className="text-gray-500 text-sm">
                    {customerData?.mobile_number || userData?.mobile || 'Mobile number'}
                </p>
            </div>
        </div>
    </div>
</div>


            {/* Language Section */}
            <div className="mx-4 mt-4 bg-white rounded-lg p-4 shadow-sm">
                <div className="flex items-center justify-between">
                    <div className="flex items-center">
                        <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center mr-3">
                            <span className="text-gray-600 font-medium text-sm">A</span>
                        </div>
                        <span className="text-gray-900">Language (English)</span>
                    </div>
                    <button className="text-red-500 text-sm font-medium">
                        Change
                    </button>
                </div>
            </div>

            {/* Your Profile Section */}
            <div className="mx-4 mt-4 bg-white rounded-lg p-4 shadow-sm">
                <div className="flex items-center justify-between mb-4">
                    <h3 className="text-sm font-semibold text-[#000000]">Personal Information</h3>
                    {!editingProfile && (
               <button 
    onClick={() => setEditingProfile(true)}
    className="text-red-500 text-sm font-medium flex items-center"
>
    <FontAwesomeIcon icon={faEdit} className="mr-1" />
    
</button>


                    )}
                </div>

                <div className="space-y-4">
                    {/* Name Field */}
                    <div>
                        <label className="block text-xs text-gray-500 mb-2">Name</label>
                        {editingProfile ? (
                            <input
                                type="text"
                                value={profileForm.customer_name}
                                onChange={(e) => setProfileForm({...profileForm, customer_name: e.target.value})}
                                className="w-full p-3 border border-gray-300 rounded-md text-sm focus:outline-none focus:border-gray-300"
                                placeholder="Enter your name"
                            />
                        ) : (
                            <div className="w-full p-3 bg-gray-50 border border-gray-200 rounded-md">
                                <p className="text-gray-500 text-sm">{customerData?.customer_name || 'Not provided'}</p>
                            </div>
                        )}
                    </div>

                    {/* Mobile Number Field */}
                   <div>
  <div className="flex items-center justify-between mb-2">
    <label className="block text-xs text-gray-500">
      Mobile Number
    </label>
  </div>

  {editingProfile ? (
    <>
      <input
        type="text"
        value={profileForm.mobile_number}
        onChange={handleMobileChange}
        maxLength={10}
        className={`w-full p-3 border rounded-md text-sm focus:outline-none ${
          mobileError ? 'border-red-500' : 'border-gray-300'
        }`}
        placeholder="Enter mobile number"
      />

      {mobileError && (
        <p className="mt-1 text-xs text-red-500">
          {mobileError}
        </p>
      )}
    </>
  ) : (
    <div className="w-full p-3 bg-gray-50 border border-gray-200 rounded-md">
      <p className="text-gray-900 text-sm">
        {customerData?.mobile_number || 'Not provided'}
      </p>
    </div>
  )}
</div>


                {editingProfile && (
    <div className="flex justify-start pt-2">
        <button 
            onClick={handleProfileSave}
            disabled={isSaving}
            className={`px-6 py-2 rounded-md text-sm font-medium mr-3 ${
                isSaving 
                    ? 'bg-gray-400 text-white cursor-not-allowed' 
                    : 'bg-red-500 text-white hover:bg-red-600'
            }`}
        >
            {isSaving ? 'Saving...' : 'Save'}
        </button>
        <button 
            onClick={() => setEditingProfile(false)}
            disabled={isSaving}
            className="bg-gray-300 text-gray-700 px-6 py-2 rounded-md text-sm font-medium"
        >
            Cancel
        </button>
    </div>
)}
                </div>
            </div>

            {/* Contact Information Section */}
    <div className="mx-4 mt-4 bg-white rounded-lg p-4 mb-12 shadow-sm">
    <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold text-[#000000]">Company Information</h3>
        {!editingContact && (
            <button 
                onClick={() => setEditingContact(true)}
                className="text-red-500 text-sm font-medium flex items-center"
            >
                <FontAwesomeIcon icon={faEdit} className="mr-1" />
            </button>
        )}
    </div>

    <div className="space-y-4">
        {/* Company Name */}
        <div>
            <label className="block text-xs text-gray-500 mb-2">Company Name</label>
            {editingContact ? (
                <input
                    type="text"
                    value={contactForm.company_name}
                    onChange={(e) => setContactForm({...contactForm, company_name: e.target.value})}
                    className="w-full p-3 border border-gray-300 rounded-md text-sm focus:outline-none focus:border-gray-300"
                    placeholder="Enter company name"
                />
            ) : (
                <div className="w-full p-3 bg-gray-50 border border-gray-200 rounded-md">
                    <p className="text-gray-900 text-sm">{customerData?.company_name || 'Not provided'}</p>
                </div>
            )}
        </div>

        {/* Type of Firm - WITH DROPDOWN */}
        <div className="relative" ref={firmTypeRef}>
            <label className="block text-xs text-gray-500 mb-2">Type of Firm</label>
            {editingContact ? (
                <>
                    <div
                        className="w-full p-3 border border-gray-300 rounded-md text-sm focus:outline-none focus:border-gray-300 cursor-pointer flex justify-between items-center"
                        onClick={() => setShowFirmTypeDropdown(!showFirmTypeDropdown)}
                    >
                        <span className={contactForm.type_of_firm ? "text-gray-900" : "text-gray-400"}>
                            {contactForm.type_of_firm || "Select type of firm"}
                        </span>
                        <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                    
                    {showFirmTypeDropdown && (
                        <div className="absolute z-10 mt-1 w-full bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-y-auto">
                            <div
                                className={`py-2 px-4 hover:bg-gray-50 cursor-pointer text-sm ${
                                    contactForm.type_of_firm === "Sole Proprietorship" 
                                        ? "bg-gray-100 text-gray-500" 
                                        : "text-gray-700"
                                }`}
                                onClick={() => {
                                    setContactForm({...contactForm, type_of_firm: "Sole Proprietorship"});
                                    setShowFirmTypeDropdown(false);
                                }}
                            >
                                Sole Proprietorship
                            </div>
                            <div
                                className={`py-2 px-4 hover:bg-gray-50 cursor-pointer text-sm ${
                                    contactForm.type_of_firm === "Partnership" 
                                        ? "bg-gray-100 text-gray-500" 
                                        : "text-gray-700"
                                }`}
                                onClick={() => {
                                    setContactForm({...contactForm, type_of_firm: "Partnership"});
                                    setShowFirmTypeDropdown(false);
                                }}
                            >
                                Partnership
                            </div>
                            <div
                                className={`py-2 px-4 hover:bg-gray-50 cursor-pointer text-sm ${
                                    contactForm.type_of_firm === "Limited Liability Partnership (LLP)" 
                                        ? "bg-gray-100 text-gray-500" 
                                        : "text-gray-700"
                                }`}
                                onClick={() => {
                                    setContactForm({...contactForm, type_of_firm: "Limited Liability Partnership (LLP)"});
                                    setShowFirmTypeDropdown(false);
                                }}
                            >
                                Limited Liability Partnership (LLP)
                            </div>
                            <div
                                className={`py-2 px-4 hover:bg-gray-50 cursor-pointer text-sm ${
                                    contactForm.type_of_firm === "Private Limited Company" 
                                        ? "bg-gray-100 text-gray-500" 
                                        : "text-gray-700"
                                }`}
                                onClick={() => {
                                    setContactForm({...contactForm, type_of_firm: "Private Limited Company"});
                                    setShowFirmTypeDropdown(false);
                                }}
                            >
                                Private Limited Company
                            </div>
                        </div>
                    )}
                </>
            ) : (
                <div className="w-full p-3 bg-gray-50 border border-gray-200 rounded-md">
                    <p className="text-gray-900 text-sm">{customerData?.type_of_firm || 'Not provided'}</p>
                </div>
            )}
        </div>

        {/* GST */}
        <div>
            <label className="block text-xs text-gray-500 mb-2">GST Number</label>
           {editingContact ? (
    <>
      <input
        type="text"
        value={contactForm.gstin}
        maxLength={15}
        onChange={handleGstChange}
        className={`w-full p-3 border rounded-md text-sm focus:outline-none ${
          gstError ? 'border-red-500' : 'border-gray-300'
        }`}
        placeholder="Enter GST number"
      />

      {gstError && (
        <p className="mt-1 text-xs text-red-500">
          {gstError}
        </p>
      )}
    </>
  ) : (
    <div className="w-full p-3 bg-gray-50 border border-gray-200 rounded-md">
      <p className="text-gray-900 text-sm">
        {customerData?.gstin || 'Not provided'}
      </p>
    </div>
  )}
</div>

        {/* PAN */}
        <div>
            <label className="block text-xs text-gray-500 mb-2">PAN Number</label>
            {editingContact ? (
                <input
                    type="text"
                    value={contactForm.pan}
                    readOnly
                    className="w-full p-3 border border-gray-300 rounded-md text-sm focus:outline-none focus:border-gray-300"
                    placeholder="Enter PAN number"
                />
            ) : (
                <div className="w-full p-3 bg-gray-50 border border-gray-200 rounded-md">
                    <p className="text-gray-900 text-sm">{customerData?.pan || 'Not provided'}</p>
                </div>
            )}
        </div>

        {/* Association - WITH DROPDOWN */}
        <div className="relative" ref={associationRef}>
            <label className="block text-xs text-gray-500 mb-2">Association</label>
            {editingContact ? (
                <>
                    <div
                        className="w-full p-3 border border-gray-300 rounded-md text-sm focus:outline-none focus:border-gray-300 cursor-pointer flex justify-between items-center"
                        onClick={() => setShowAssociationDropdown(!showAssociationDropdown)}
                    >
                        <span className={contactForm.association ? "text-gray-900" : "text-gray-400"}>
                            {contactForm.association || "Select association"}
                        </span>
                        <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                    </div>
                    
                    {showAssociationDropdown && (
                        <div className="absolute z-10 mt-1 w-full bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-y-auto">
                            <div
                                className={`py-2 px-4 hover:bg-gray-50 cursor-pointer text-sm ${
                                    contactForm.association === "NAREDCO" 
                                        ? "bg-gray-100 text-gray-500" 
                                        : "text-gray-700"
                                }`}
                                onClick={() => {
                                    setContactForm({...contactForm, association: "NAREDCO"});
                                    setShowAssociationDropdown(false);
                                }}
                            >
                                NAREDCO
                            </div>
                            <div
                                className={`py-2 px-4 hover:bg-gray-50 cursor-pointer text-sm ${
                                    contactForm.association === "CREDAI" 
                                        ? "bg-gray-100 text-gray-500" 
                                        : "text-gray-700"
                                }`}
                                onClick={() => {
                                    setContactForm({...contactForm, association: "CREDAI"});
                                    setShowAssociationDropdown(false);
                                }}
                            >
                                CREDAI
                            </div>
                            <div
                                className={`py-2 px-4 hover:bg-gray-50 cursor-pointer text-sm ${
                                    contactForm.association === "BAI" 
                                        ? "bg-gray-100 text-gray-500" 
                                        : "text-gray-700"
                                }`}
                                onClick={() => {
                                    setContactForm({...contactForm, association: "BAI"});
                                    setShowAssociationDropdown(false);
                                }}
                            >
                                BAI
                            </div>
                        </div>
                    )}
                </>
            ) : (
                <div className="w-full p-3 bg-gray-50 border border-gray-200 rounded-md">
                    <p className="text-gray-900 text-sm">{customerData?.association || 'Not provided'}</p>
                </div>
            )}
        </div>

   {editingContact && (
    <div className="flex justify-start pt-2">
        <button 
            onClick={handleContactSave}
            disabled={isSaving}
            className={`px-6 py-2 rounded-md text-sm font-medium mr-3 ${
                isSaving 
                    ? 'bg-gray-400 text-white cursor-not-allowed' 
                    : 'bg-red-500 text-white hover:bg-red-600'
            }`}
        >
            {isSaving ? 'Saving...' : 'Save'}
        </button>
        <button 
            onClick={() => setEditingContact(false)}
            disabled={isSaving}
            className="bg-gray-300 text-gray-700 px-6 py-2 rounded-md text-sm font-medium"
        >
            Cancel
        </button>
    </div>
)}
    </div>
</div>


            {/* Logout Button */}
            <div className="mx-4 mb-14 -mt-2">
                <button 
                    onClick={handleLogout}
                    className="w-full bg-white rounded-lg p-4 shadow-sm flex items-center justify-center hover:bg-gray-50"
                >
                    <FontAwesomeIcon icon={faSignOutAlt} className="text-red-500 mr-2" />
                    <span className="text-red-500 font-medium">Logout</span>
                </button>
            </div>

            {/* <MenuFooter /> */}
        </div>
    );
}

export default ProfileAccount;
